import {
  ArendeType,
  KanalType,
  KundgruppType,
  LamnaOverType,
} from "@/composables/KundserviceAppApiClient";
import type { Option } from "@/types/form";

export function kanalTypeToOption(type: KanalType): Option {
  return { id: type, label: KanalTypeLabels[type] };
}

export function kundgruppTypeToOption(type: KundgruppType): Option {
  return { id: type, label: KundgruppTypeLabels[type] };
}

export function lamnaOverTypeToOption(type: LamnaOverType): Option {
  return { id: type, label: LamnaOverTypeLabels[type] };
}

export const KanalTypeLabels: Record<KanalType, string> = {
  [KanalType.Epost]: "E-post",
  [KanalType.Telefon]: "Telefon",
  [KanalType.Chat]: "Chat",
  [KanalType.Kundservice]: "Kundservice",
  [KanalType.Radgivningstjansten]: "Rådgivningstjänsten",
  [KanalType.InloggadPaAvtalatSe]: "Inloggad på avtalat.se",
  [KanalType.Freshdesk]: "Freshdesk",
  [KanalType.FysisktMote]: "Fysiskt möte",
  [KanalType.DigitaltMote]: "Digitalt möte",
};

export const AllKanalTypeOptions =
  Object.values(KanalType).map(kanalTypeToOption);

export const KundgruppTypeLabels: Record<KundgruppType, string> = {
  [KundgruppType.Arbetare]: "Arbetare",
  [KundgruppType.Arbetsgivare]: "Arbetsgivare",
  [KundgruppType.Tjansteman]: "Tjänsteman",
  [KundgruppType.Arbetsgivarforbund]: "Arbetsgivarförbund",
  [KundgruppType.Fackforbund]: "Fackförbund",
  [KundgruppType.Partsbolag]: "Partsbolag",
  [KundgruppType.Forsakringsinformator]: "Försäkringsinformatör",
  [KundgruppType.Ovrigt]: "Övrigt",
};

export const AllKundgruppTypeOptions = Object.values(KundgruppType).map(
  kundgruppTypeToOption,
);

export const LamnaOverTypeLabels: Record<LamnaOverType, string> = {
  [LamnaOverType.Kundservice]: "Kundservice",
  [LamnaOverType.Collectum]: "Collectum",
  [LamnaOverType.CollectumForetag]: "Collectum företag",
  [LamnaOverType.Radgivningstjansten]: "Rådgivningstjänsten",
  [LamnaOverType.SupportForInformatorer]: "Support för Informatörer",
  [LamnaOverType.Klagomal]: "Klagomål",
  [LamnaOverType.Legal]: "Legal",
  [LamnaOverType.Leveransadministration]: "Leveransadministration",
  [LamnaOverType.Webbgruppen]: "Webbgruppen",
  [LamnaOverType.AfaForsakring]: "AFA",
  [LamnaOverType.Alecta]: "Alecta",
  [LamnaOverType.Fora]: "Fora",
  [LamnaOverType.Nej]: "Nej",
};

export const ArendetypOptions: Option[] = [
  { id: ArendeType.Kundservicearende, label: "Kundserviceärende" },
];

export const DEFAULT_API_ERROR_MESSAGE =
  "Något har gått fel. Kontakta IT-drift.";

export function InternalCommentErrorMessage(lamnaOverTill: LamnaOverType) {
  return (
    "Intern kommentar måste anges" +
    (lamnaOverTill !== LamnaOverType.Nej
      ? " vid överlämning till externa tjänster"
      : "")
  );
}
